export default {
    name: 'TriangleDown',
    dimensions: { width: 10, height: 7 },
    content: `
    <path d="M1.00001 0C0.615604 0 0.265226 0.220346 0.0987061 0.566811C-0.0678138 0.913277 -0.0209954 1.32453 0.219141 1.6247L4.21914 6.62469C4.40891 6.86191 4.69623 7 5.00001 7C5.30379 7 5.59111 6.86191 5.78088 6.62469L9.78088 1.6247C10.021 1.32452 10.0678 0.913277 9.90131 0.566811C9.73479 0.220346 9.38441 0 9.00001 0H1.00001Z" fill="currentColor"/>
`
};
